const ColorItems = {
  ttrGreen: '#6EFA8F',
  ttrDarkGreen: '#007C49',
  ttrMediumGreen: '#009251',
  ttrLightBlue: '#0c86ff',
  ttrMediumBlue: '#65ABF1',
  ttrDarkBlue: '#2D3966',
  ttrGold: '#F4B722',
  ttrWhite: '#fff',
  ttrDarkGray: '#2D3966',
  ttrDotRed: '#ff0059',
  ttrDotPink: '#ff8cf7',
  ttrDotBlue: '#00c3ff',
  ttrDotDarkGray: '#adadad',
  ttrRed: 'rgb(210,41,41)',
};

export const globalColors = {
  ...ColorItems,
  primary: ColorItems.ttrMediumBlue,
  secondary: ColorItems.ttrLightBlue,
  aux: ColorItems.ttrGold,
  aux2: ColorItems.ttrDarkBlue,
};
